
<template>
    <div class="sticky">
        <ul class="ps-0 for_desktop">
            <li><NuxtLink :to="localePath('/customer-service/shipping-policy')">Free Shipping</NuxtLink></li>
            <li v-if="$country.is_india"><NuxtLink :to="localePath('/customer-service/return-policy')">Free 15 Day Returns</NuxtLink></li>
            <li v-else><NuxtLink :to="localePath('/customer-service/return-policy')">Free 30 Day Returns</NuxtLink></li>
            <li><NuxtLink :to="localePath('/customer-service/exchange-policy')">Lifetime Trade-In</NuxtLink></li>
            <li><NuxtLink :to="localePath('/customer-service/ring-resizing')">Free Ring resizing</NuxtLink></li>
            <li><NuxtLink :to="localePath('/customer-service/life-time-warranty')">Lifetime warranty</NuxtLink></li>
            <li><NuxtLink :to="localePath('/customer-service/ring-engraving')">Free Engraving</NuxtLink></li>
            <li><NuxtLink :to="localePath('/customer-service/payment-options')">Payment Options</NuxtLink></li>
            <li><NuxtLink v-if="$country.is_india" :to="localePath('/customer-service/buyback-policy')">Assured Buyback</NuxtLink></li>
        </ul>

        <div class="for_mobile mb-5">
            <div class="">
                <FilterCustomDropDown 
                    :routecustom="routecustom"
                    type="custompolicy"
                />
            </div>
        </div>

    </div>
</template>
  
<script setup>
    const localePath = useLocalePath()
    const { $country } = useNuxtApp()

    const routecustom = $country?.is_india ? {
        '/customer-service/shipping-policy' : 'Free Shipping',
        '/customer-service/return-policy' : 'Free 15 Day Returns',
        '/customer-service/exchange-policy' : 'Lifetime Trade-In',
        '/customer-service/ring-resizing' : 'Free Ring resizing',
        '/customer-service/life-time-warranty' : 'Lifetime warranty',
        '/customer-service/ring-engraving' : 'Free Engraving',
        '/customer-service/payment-options' : 'Payment Options',
        '/customer-service/buyback-policy' : 'Assured Buyback'
    }
    : 
    {
        '/customer-service/shipping-policy' : 'Free Shipping',
        '/customer-service/return-policy' : 'Free 30 Day Returns',
        '/customer-service/exchange-policy' : 'Lifetime Trade-In',
        '/customer-service/ring-resizing' : 'Free Ring resizing',
        '/customer-service/life-time-warranty' : 'Lifetime warranty',
        '/customer-service/ring-engraving' : 'Free Engraving',
        '/customer-service/payment-options' : 'Payment Options',

    }

</script>

<style scoped>
ul li{
    list-style: none;
    padding: 2px 0;
}
ul li a {
    color: #000;
    font-weight: 600;
    line-height: 2;
    text-transform: uppercase;
    font-size: 13px;
}
ul li a.router-link-active.router-link-exact-active{
    color: #508a7b;
}
select{
    width: 100%;
}

@media(min-width: 768px){
    .sticky{
        position: sticky;
        top: 30px;
        height: -webkit-fit-content;
        height: -moz-fit-content;
        height: fit-content;
    }
}
</style>
